import { queryBot2 } from 'boot/axios';

export async function loadPortfolioByUserId (userId) {
    return queryBot2('loadPortfolioByUserId1', { userId }).then(async (r) => {
        let portfolio;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            const flowId = result.flow_id;
            if (flowId) {
                await queryBot2('loadPortfolioByUserId2', { flowId: `%"${flowId}"%` }).then((ra) => {
                    const [resulta] = ra.data;
                    if (resulta && typeof resulta === 'object') {
                        portfolio = resulta;
                    }
                });
            }
        }
        return portfolio;
    });
}

export async function loadPortfolioById (id) {
    return queryBot2('loadPortfolioById', { id }).then((r) => {
        let portfolio;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            portfolio = result;
        }
        return portfolio;
    });
}

export default loadPortfolioById;
